import { EventStatusCode } from '../redux/Event/Status/EventStatus.type';

export interface EmailTemplate {
  code: EventStatusCode;
  template: string;
  id?: string;
}

export enum EmailTemplateVariables {
  CANDIDATE_FULL_NAME = '{% CANDIDATE_FULL_NAME %}',
  CANDIDATE_EMAIL = '{% CANDIDATE_EMAIL %}',
  ME_FULL_NAME = '{% ME_FULL_NAME %}',
}
